/* ==========================================================================
   v20 (Claude, 15.10.2026)
   - Produktkarten: Punkte der Wisch-Galerie, Bilder 2 und 3 rechtzeitig laden (nur Touch-Geräte)
   - Kollektionen: Sortierung, „Mehr laden“ (die ersten zwei Seiten automatisch beim Scrollen),
     Rücksprung an dieselbe Stelle, Beschreibung auf dem Handy kürzen, „Nach oben“
   - Produktseite: Echtheitshinweis direkt unter die Trustoo-Bewertungen setzen
   Berührt keine Warenkorb-, Kassen- oder Tracking-Funktionen.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.add('v20-js');

  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var isTouch = mq('(hover: none)');

  /* ---------- Produktkarten ---------- */

  // Punkte: Scroll-Ereignisse der Bildleisten (blubbern nicht hoch, daher „capture“ am Dokument)
  doc.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.hasAttribute('data-pc-track')) return;
    if (t._v20raf) return;
    t._v20raf = window.requestAnimationFrame(function () {
      t._v20raf = 0;
      var w = t.clientWidth || 1;
      var idx = Math.round(t.scrollLeft / w);
      var dots = t.parentNode ? t.parentNode.querySelectorAll('.pc-dots i') : [];
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === idx);
      if (idx > 0) loadImgs(t, '.product-card__img--extra');
    });
  }, { capture: true, passive: true });

  function loadImgs(scope, sel) {
    var imgs = scope.querySelectorAll(sel);
    for (var k = 0; k < imgs.length; k++) {
      var img = imgs[k];
      if (img._v20pre) continue;
      img._v20pre = true;
      try { img.loading = 'eager'; } catch (x) {}
      var src = img.currentSrc || img.getAttribute('src');
      if (src) { var pre = new Image(); pre.src = src; }
    }
  }

  // Model-Foto laden, sobald die Karte in die Nähe des Bildschirms kommt; Detailbild beim ersten Wischen
  var cardIO = null;
  if (isTouch && 'IntersectionObserver' in window) {
    cardIO = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (!entries[k].isIntersecting) continue;
        cardIO.unobserve(entries[k].target);
        loadImgs(entries[k].target, '.product-card__img--alt');
      }
    }, { rootMargin: '150px 0px' });
  }
  function initCards(scope) {
    if (!cardIO) return;
    var cards = (scope || doc).querySelectorAll('.product-card--slides');
    for (var k = 0; k < cards.length; k++) {
      if (cards[k]._v20seen) continue;
      cards[k]._v20seen = true;
      cardIO.observe(cards[k]);
    }
  }
  initCards(doc);

  /* ---------- Kollektion ---------- */

  var grid = doc.querySelector('[data-v20-grid]');
  if (grid) initCollection(grid);

  function initCollection(grid) {
    // Sortierung: Auswahl ändern = Seite neu laden (ohne JavaScript per Knopf „OK“)
    var sel = doc.querySelector('[data-v20-sort]');
    if (sel) {
      sel.addEventListener('change', function () {
        var v = sel.value;
        window.location.href = window.location.pathname + (v ? '?sort_by=' + encodeURIComponent(v) : '');
      });
    }

    // Beschreibung auf dem Handy auf zwei Zeilen kürzen
    var desc = doc.querySelector('[data-v20-desc]');
    if (desc && mq('(max-width: 700px)')) {
      desc.classList.add('is-clamped');
      if (desc.scrollHeight > desc.clientHeight + 6) {
        var more = doc.createElement('button');
        more.type = 'button';
        more.className = 'cdesc-more';
        more.textContent = 'Mehr lesen';
        more.addEventListener('click', function () {
          var clamped = desc.classList.toggle('is-clamped');
          more.textContent = clamped ? 'Mehr lesen' : 'Weniger anzeigen';
        });
        desc.parentNode.insertBefore(more, desc.nextSibling);
      } else {
        desc.classList.remove('is-clamped');
      }
    }

    // „Nach oben“
    var top = doc.createElement('button');
    top.type = 'button';
    top.className = 'totop';
    top.setAttribute('aria-label', 'Nach oben');
    top.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    doc.body.appendChild(top);
    var topTick = false;
    window.addEventListener('scroll', function () {
      if (topTick) return;
      topTick = true;
      window.requestAnimationFrame(function () {
        topTick = false;
        top.classList.toggle('is-on', window.pageYOffset > window.innerHeight * 1.5);
      });
    }, { passive: true });

    // „Mehr laden“
    var box = doc.querySelector('[data-v20-more]');
    var btn = box && box.querySelector('[data-v20-more-btn]');
    if (!box || !btn || !window.fetch || !window.DOMParser) return;
    var countEl = box.querySelector('[data-v20-more-count]');
    var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
    var AUTO_PAGES = 2;          // so viele Seiten laden beim Scrollen von selbst, danach per Knopf
    var loaded = 0;              // nachgeladene Seiten
    var busy = false;
    var failed = false;
    var KEY = 'v20coll:' + window.location.pathname + window.location.search;

    var seen = {};
    var first = grid.querySelectorAll('.product-card');
    for (var k = 0; k < first.length; k++) seen[first[k].getAttribute('href')] = 1;

    function updateCount() {
      if (!countEl || !total) return;
      var n = grid.querySelectorAll('.product-card').length;
      countEl.textContent = Math.min(n, total) + ' von ' + total + ' Produkten';
    }

    function finish() {
      if (box && box.parentNode) box.parentNode.removeChild(box);
      btn = null;
      if (autoIO) autoIO.disconnect();
    }

    function loadNext(done) {
      if (busy || !btn) { if (done) done(false); return; }
      var url = btn.getAttribute('href');
      if (!url) { finish(); if (done) done(false); return; }
      busy = true;
      box.classList.add('is-loading');
      btn.textContent = 'Lädt …';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var g = d.querySelector('[data-v20-grid]');
          var frag = doc.createDocumentFragment();
          if (g) {
            for (var i = 0; i < g.children.length; i++) {
              var c = g.children[i];
              if (!c.classList || !c.classList.contains('product-card')) continue;
              var href = c.getAttribute('href');
              if (seen[href]) continue;           // doppelte Produkte (z. B. neue Produkte während des Blätterns) überspringen
              seen[href] = 1;
              frag.appendChild(doc.importNode(c, true));
            }
          }
          grid.appendChild(frag);
          initCards(grid);
          loaded++;
          busy = false;
          box.classList.remove('is-loading');
          var nb = d.querySelector('[data-v20-more-btn]');
          if (nb && nb.getAttribute('href')) {
            btn.setAttribute('href', nb.getAttribute('href'));
            btn.textContent = 'Mehr laden';
          } else {
            finish();
          }
          updateCount();
          if (done) done(true);
        })
        .catch(function () {
          busy = false;
          failed = true;                          // nächster Klick öffnet die Seite ganz normal
          box.classList.remove('is-loading');
          if (btn) btn.textContent = 'Mehr laden';
          if (done) done(false);
        });
    }

    btn.addEventListener('click', function (e) {
      if (failed) return;
      e.preventDefault();
      loadNext();
    });

    var autoIO = null;
    if ('IntersectionObserver' in window) {
      autoIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && loaded < AUTO_PAGES && !failed) loadNext();
        }
      }, { rootMargin: '0px 0px 700px 0px' });
    }

    // Stand merken, damit „Zurück“ vom Produkt an dieselbe Stelle führt
    function save() {
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ p: loaded, y: window.pageYOffset, t: Date.now() }));
      } catch (x) {}
    }
    grid.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a.product-card')) save();
    }, true);
    window.addEventListener('pagehide', save);

    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (x) {}
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var isBack = nav ? nav.type === 'back_forward' : !!(window.performance && performance.navigation && performance.navigation.type === 2);

    if (isBack && saved && saved.p > 0 && Date.now() - saved.t < 30 * 60 * 1000) {
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (x) {}
      var want = Math.min(saved.p, 10);
      var step = function () {
        if (loaded >= want || !btn) {
          window.scrollTo(0, saved.y);
          if (autoIO && btn) autoIO.observe(box);
          return;
        }
        loadNext(function (ok) { if (ok) step(); else { window.scrollTo(0, saved.y); } });
      };
      step();
    } else if (autoIO) {
      autoIO.observe(box);
    }
  }

  /* ---------- Produktseite: Echtheitshinweis unter den Trustoo-Bewertungen ---------- */

  var note = doc.querySelector('[data-dd-review-note]');
  if (note) {
    var placeNote = function () {
      var w = doc.getElementById('trustoo-widget-wrapper');
      if (!w || !w.parentNode) return false;
      if (w.nextSibling !== note) w.parentNode.insertBefore(note, w.nextSibling);
      note.hidden = false;
      return true;
    };
    placeNote();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { placeNote(); });
      mo.observe(doc.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
  }
})();
